import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { CheckCircle, ArrowRight, Settings, Wrench, RefreshCw, Headphones, Database, Zap } from 'lucide-react'

const OdooPartner = () => {
  const services = [
    {
      icon: <Settings className="w-8 h-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="1:1" data-component-id="client/src/pages/OdooPartner.jsx:1:1" />,
      title: 'Odoo Implementation',
      description: 'End-to-end deployment tailored to your business processes',
      link: '/services/odoo-implementation'
    },
    {
      icon: <Wrench className="w-8 h-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="2:1" data-component-id="client/src/pages/OdooPartner.jsx:2:1" />,
      title: 'Custom Module Development',
      description: 'Bespoke modules designed for your unique requirements',
      link: '/services/odoo-customization'
    },
    {
      icon: <RefreshCw className="w-8 h-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="3:1" data-component-id="client/src/pages/OdooPartner.jsx:3:1" />,
      title: 'Odoo Migration',
      description: 'Seamless upgrades to the latest Odoo versions',
      link: '/services/odoo-migration'
    },
    {
      icon: <Headphones className="w-8 h-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="4:1" data-component-id="client/src/pages/OdooPartner.jsx:4:1" />,
      title: '24/7 Support',
      description: 'Round-the-clock maintenance and technical assistance',
      link: '/services/odoo-support'
    },
  ]

  const modules = [
    'Sales & CRM', 'Accounting', 'Inventory', 'Manufacturing',
    'Purchase', 'HR & Payroll', 'Project Management', 'E-Commerce',
    'Point of Sale', 'Marketing Automation', 'Helpdesk', 'Quality Control'
  ]

  const industries = [
    'Manufacturing', 'Retail & E-Commerce', 'Healthcare',
    'Professional Services', 'Distribution', 'Construction',
    'Food & Beverage', 'Logistics', 'Education'
  ]

  return (
    <div className="min-h-screen pt-20" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="5:1" data-component-id="client/src/pages/OdooPartner.jsx:5:1">
      <section 
        className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-component-path="client/src/pages/OdooPartner.jsx"
        data-component-line="6:3"
        data-component-id="client/src/pages/OdooPartner.jsx:6:3"
      >
        <div className="absolute inset-0 bg-dark-primary/85" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="14:5" data-component-id="client/src/pages/OdooPartner.jsx:14:5"></div>
        
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="16:5" data-component-id="client/src/pages/OdooPartner.jsx:16:5">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            data-component-path="client/src/pages/OdooPartner.jsx"
            data-component-line="17:7"
            data-component-id="client/src/pages/OdooPartner.jsx:17:7"
          >
            <div className="inline-block px-6 py-3 bg-purple-600/20 border border-purple-500 rounded-full mb-6" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="22:9" data-component-id="client/src/pages/OdooPartner.jsx:22:9">
              <span className="text-purple-400 font-bold text-lg" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="23:11" data-component-id="client/src/pages/OdooPartner.jsx:23:11">Official Odoo Partner</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="25:9" data-component-id="client/src/pages/OdooPartner.jsx:25:9">
              Enterprise ERP <span className="text-gradient" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="26:31" data-component-id="client/src/pages/OdooPartner.jsx:26:31">Excellence</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="28:9" data-component-id="client/src/pages/OdooPartner.jsx:28:9">
              Transform your business operations with Odoo ERP. As an Official Partner, we deliver 
              world-class implementation, customization, and support services.
            </p>
            <Link to="/contact" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="32:9" data-component-id="client/src/pages/OdooPartner.jsx:32:9">
              <button className="h-14 px-8 bg-neon-green text-dark-primary font-bold rounded-xl hover:shadow-lg hover:shadow-neon-green/50 transition-all duration-200 flex items-center justify-center gap-2 mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="33:11" data-component-id="client/src/pages/OdooPartner.jsx:33:11">
                Schedule ERP Consultation <ArrowRight className="w-5 h-5" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="34:47" data-component-id="client/src/pages/OdooPartner.jsx:34:47" />
              </button>
            </Link>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="41:3" data-component-id="client/src/pages/OdooPartner.jsx:41:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="42:5" data-component-id="client/src/pages/OdooPartner.jsx:42:5">
          <div className="text-center mb-16" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="43:7" data-component-id="client/src/pages/OdooPartner.jsx:43:7">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="44:9" data-component-id="client/src/pages/OdooPartner.jsx:44:9">
              Our Odoo <span className="text-gradient" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="45:27" data-component-id="client/src/pages/OdooPartner.jsx:45:27">Services</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="47:9" data-component-id="client/src/pages/OdooPartner.jsx:47:9">
              Comprehensive Odoo solutions from implementation to ongoing support
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="52:7" data-component-id="client/src/pages/OdooPartner.jsx:52:7">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="glass-panel rounded-xl p-6 hover:border-purple-500 transition-all group"
                data-component-path="client/src/pages/OdooPartner.jsx"
                data-component-line="54:11"
                data-component-id="client/src/pages/OdooPartner.jsx:54:11"
              >
                <Link to={service.link} data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="62:13" data-component-id="client/src/pages/OdooPartner.jsx:62:13">
                  <div className="w-16 h-16 bg-purple-600/20 rounded-xl flex items-center justify-center mb-4 text-purple-400 group-hover:bg-purple-600/30 transition-all" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="63:15" data-component-id="client/src/pages/OdooPartner.jsx:63:15">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-white" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="66:15" data-component-id="client/src/pages/OdooPartner.jsx:66:15">{service.title}</h3>
                  <p className="text-gray-400 text-sm mb-4" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="67:15" data-component-id="client/src/pages/OdooPartner.jsx:67:15">{service.description}</p>
                  <div className="flex items-center gap-2 text-purple-400 text-sm font-semibold" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="68:15" data-component-id="client/src/pages/OdooPartner.jsx:68:15">
                    Learn More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="69:28" data-component-id="client/src/pages/OdooPartner.jsx:69:28" />
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-secondary" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="77:3" data-component-id="client/src/pages/OdooPartner.jsx:77:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="78:5" data-component-id="client/src/pages/OdooPartner.jsx:78:5">
          <div className="text-center mb-16" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="79:7" data-component-id="client/src/pages/OdooPartner.jsx:79:7">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="80:9" data-component-id="client/src/pages/OdooPartner.jsx:80:9">
              Odoo <span className="text-gradient" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="81:19" data-component-id="client/src/pages/OdooPartner.jsx:81:19">Modules</span> We Master
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="83:9" data-component-id="client/src/pages/OdooPartner.jsx:83:9">
              Expert implementation across all Odoo modules
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="88:7" data-component-id="client/src/pages/OdooPartner.jsx:88:7">
            {modules.map((module, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.05 }}
                className="glass-panel rounded-xl p-4 flex items-center gap-3 hover:border-purple-500 transition-all"
                data-component-path="client/src/pages/OdooPartner.jsx"
                data-component-line="90:11"
                data-component-id="client/src/pages/OdooPartner.jsx:90:11"
              >
                <CheckCircle className="w-5 h-5 text-purple-400 flex-shrink-0" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="96:13" data-component-id="client/src/pages/OdooPartner.jsx:96:13" />
                <span className="text-white font-semibold" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="97:13" data-component-id="client/src/pages/OdooPartner.jsx:97:13">{module}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="104:3" data-component-id="client/src/pages/OdooPartner.jsx:104:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="105:5" data-component-id="client/src/pages/OdooPartner.jsx:105:5">
          <div className="text-center mb-16" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="106:7" data-component-id="client/src/pages/OdooPartner.jsx:106:7">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="107:9" data-component-id="client/src/pages/OdooPartner.jsx:107:9">
              Industries We <span className="text-gradient" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="108:31" data-component-id="client/src/pages/OdooPartner.jsx:108:31">Serve</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="110:9" data-component-id="client/src/pages/OdooPartner.jsx:110:9">
              Tailored Odoo solutions for diverse business sectors
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="115:7" data-component-id="client/src/pages/OdooPartner.jsx:115:7">
            {industries.map((industry, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="glass-panel rounded-xl p-6 text-center hover:border-neon-green transition-all"
                data-component-path="client/src/pages/OdooPartner.jsx"
                data-component-line="117:11"
                data-component-id="client/src/pages/OdooPartner.jsx:117:11"
              >
                <h3 className="text-xl font-bold text-white" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="123:13" data-component-id="client/src/pages/OdooPartner.jsx:123:13">{industry}</h3>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-secondary" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="130:3" data-component-id="client/src/pages/OdooPartner.jsx:130:3">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="131:5" data-component-id="client/src/pages/OdooPartner.jsx:131:5">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="glass-panel rounded-2xl p-12 border-purple-500"
            data-component-path="client/src/pages/OdooPartner.jsx"
            data-component-line="132:7"
            data-component-id="client/src/pages/OdooPartner.jsx:132:7"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="137:9" data-component-id="client/src/pages/OdooPartner.jsx:137:9">
              Ready to Transform with <span className="text-gradient" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="138:43" data-component-id="client/src/pages/OdooPartner.jsx:138:43">Odoo</span>?
            </h2>
            <p className="text-gray-400 text-lg mb-8" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="140:9" data-component-id="client/src/pages/OdooPartner.jsx:140:9">
              Schedule a consultation with our Odoo experts to discuss your ERP requirements
            </p>
            <Link to="/contact" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="143:9" data-component-id="client/src/pages/OdooPartner.jsx:143:9">
              <button className="h-14 px-8 bg-neon-green text-dark-primary font-bold rounded-xl hover:shadow-lg hover:shadow-neon-green/50 transition-all duration-200 flex items-center justify-center gap-2 mx-auto" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="144:11" data-component-id="client/src/pages/OdooPartner.jsx:144:11">
                Book ERP Consultation <ArrowRight className="w-5 h-5" data-component-path="client/src/pages/OdooPartner.jsx" data-component-line="145:42" data-component-id="client/src/pages/OdooPartner.jsx:145:42" />
              </button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default OdooPartner